import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'
import axios from "axios";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';

import VideocamIcon from '@mui/icons-material/Videocam';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import BarChartIcon from '@mui/icons-material/BarChart';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import PersonIcon from '@mui/icons-material/Person';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import Link from '@mui/material/Link';

const style = {
  width: '60px',
  maxWidth: 60,
  // bgcolor: 'background.paper',
};


function LeftComponents() {
  const authentication = useContext(Authentication);
  const [user, setuser] = useState();

  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;

    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
      setuser(response.data)
    });

  }, []);
  if (!user) return null;
  return (
    <div className="left" style={{
        width: '60px',
        height: '100%',
        float: 'left',
        margin: 0,
        padding: 0,
        position: 'fixed',
        top: '50px',
        zIndex: 1000,
        backgroundColor: '#6d94b5'
      }}>
      <div id="aside">
        <List sx={style} component="nav" aria-label="mailbox folders">
          {/* <ListItem style={{ padding:'8px 5px' }} button >
          <Link className='btnbox'  href="/" underline="none">
            <PeopleAltIcon className='listicon'/>
            <span className='btntext'>総務データ</span>
          </Link>
        </ListItem> */}
          <Divider />
          {/* <ListItem style={{ padding:'8px 5px' }} button divider>
          <Link className='btnbox'  href="/RecruitEarnings" underline="none">
            <BarChartIcon size="large" className='listicon'/>
            <span className='btntext'>売上データ</span>
          </Link>
        </ListItem> */}
          {/* <ListItem style={{ padding:'8px 5px' }} button>
          <Link className='btnbox' href="/RecruitLine" underline="none">
            <AdUnitsIcon size="large" className='listicon'/>
            <span className='btntext'>LINE</span>
          </Link>
        </ListItem> */}
          <Divider light />
          {/* <ListItem style={{ padding:'8px 5px' }} button>
          <Link className='btnbox'  href="/RecruitNews" underline="none">
            <NewspaperIcon size="large" className='listicon'/>
            <span className='btntext'>NEWS</span>
          </Link>
        </ListItem> */}
          <Divider />
          {/* 賃貸部・システムのみ目標・自己紹介を出す */}
          {user.am_section_id == 1 ||
            user.am_section_id == 2 ||
            user.am_section_id == 3 ||
            user.am_section_id == 4 ||
            user.am_section_id == 6 ||
            user.am_section_id == 17 ||
            user.am_section_id == 47 ||
            user.am_section_id == 24 ||
            user.am_section_id == 10 ?
            <ListItem style={{ padding:'8px 5px' }} button>
              <Link className='btnbox' href="/PersonalGoals" underline="none">
                <PersonIcon size="large" className='listicon' />
                <span className='btntext'>個人目標</span>
              </Link>
            </ListItem> : ""}
          <Divider />
          {user.am_section_id == 1 ||
            user.am_section_id == 2 ||
            user.am_section_id == 3 ||
            user.am_section_id == 4 ||
            user.am_section_id == 6 ||
            user.am_section_id == 17 ||
            user.am_section_id == 47 ||
            user.am_section_id == 24 ||
            user.am_section_id == 10 ?
            <ListItem style={{ padding:'8px 5px' }} button>
              <Link className='btnbox' href="/Introduction" underline="none">
                <PersonIcon size="large" className='listicon' />
                <span className='btntext'>自己紹介</span>
              </Link>
            </ListItem> : ""}
          <Divider />
          <ListItem style={{ padding:'8px 5px' }} button>
            <Link className='btnbox' href="/StampCard" underline="none">
              <TaskAltIcon size="large" className='listicon' />
              <span className='btntext'>スタンプ<br />カード</span>
            </Link>
          </ListItem>
          <Divider />
          <ListItem style={{ padding:'8px 5px' }} button>
            <Link className='btnbox' href="https://www.homestation.jp/manage/groupware/workflow/newapplication?f_id=42" underline="none">
              <ContentPasteGoIcon size="large" className='listicon' />
              <span className='btntext'>研修申込</span>
            </Link>
          </ListItem>
          <Divider />
          <ListItem style={{ padding:'8px 5px' }} button>
            <Link className='btnbox' href="https://www.homestation.jp/manage/groupware/workflow/newapplication?f_id=42" underline="none">
              <HeadsetMicIcon size="large" className='listicon' />
              <span className='btntext'>通信教育<br />申込</span>
            </Link>
          </ListItem>
          <Divider />
          {user.id == 1062 ||
            user.id == 1086 ||
            user.id == 1414 ||
            user.am_section_id == 10 ?
            <ListItem style={{ padding:'8px 5px' }} button>
              <Link className='btnbox' href="/StampPut" underline="none">
                <AddCircleOutlineIcon size="large" className='listicon' />
                <span className='btntext'>スタンプ<br />付与</span>
              </Link>
            </ListItem> : ""}
          <Divider />
          {user.id == 1062 ||
            user.id == 1086 ||
            user.id == 1414 ||
            user.am_section_id == 10 ?
            <ListItem style={{ padding:'8px 5px' }} button>
              <Link className='btnbox' href="/TrainingEventList" underline="none">
                <AssignmentTurnedInIcon size="large" className='listicon' />
                <span className='btntext'>登録</span>
              </Link>
            </ListItem> : ""}
            
          

            <ListItem style={{ padding:'8px 5px' }} button>
              <Link className='btnbox' href="/ReservationCall" underline="none">
                <VideocamIcon size="large" className='listicon' />
                <span className='btntext'>ビデオ<br/>通話</span>
              </Link>
            </ListItem>

        </List>
      </div >
      {/* <Route path='/Recruit' component={Recruit} /> */}
      <style jsx="true">{
        `
        .left{
          width:60px;
          height: 100%;
          float: left;
          margin: 0;
          padding: 0;
          position: fixed;
          top:50px;
          z-index: 1000;
          background-color: #6d94b5;
        }
        @media screen and (max-width: 768px) {
          .left{
            display:none;
          }
        }
        #aside {
        }
        .css-bshv44-MuiButtonBase-root-MuiListItem-root,
        .css-1ghby9w-MuiButtonBase-root-MuiListItem-root {
          
        }
        .btnbox{
          align-items: center;
          width:100%;
          display:flex;
          flex-flow: column;
          text-decoration: none;
        }
        .listicon{
          width: 30px;
          height: 30px;
          color:#fff;
        }
        .btntext{
          padding-top:3px;
          font-size:10px;
          color:#fff;
          text-align: center;
        }
        `
      }
      </style>
    </div>
  );
  // };
};

export default LeftComponents;
